import { IonIcon, IonLabel, IonList, IonPopover } from "@ionic/react";
import { add, trashBin } from "ionicons/icons";
import { Trans } from "react-i18next";

const FileActionPopover = ({ 
  isOpen, 
  itemId,
  trigger,
  onClose, 
  onCreateSession,
  onDelete,
  showCreateSession = true
}: { 
  isOpen: boolean; 
  itemId: string;
  trigger: string;
  onClose: () => void; 
  onCreateSession: (itemId: string) => void;
  onDelete: (itemId: string) => void;
  showCreateSession?: boolean;
}) => {
  const handleCreateSession = () => {
    onCreateSession(itemId);
    onClose();
  };

  const handleDelete = () => {
    onDelete(itemId);
    onClose();
  };

  return (
    <IonPopover
      isOpen={isOpen}
      trigger={trigger}
      onDidDismiss={onClose}
      showBackdrop={false}
      className="doc-popover"
    >
      <IonList className="doc-popover-list">
        {showCreateSession && (
          <div
            className="doc-popover-list-item"
            onClick={handleCreateSession}
          >
            <IonIcon icon={add} slot="start"></IonIcon>
            <IonLabel className="doc-popover-list-item-label"><Trans>Crea una nuova sessione</Trans></IonLabel>
          </div>
        )}

        <div
          className="doc-popover-list-item"
          onClick={handleDelete}
        >
          <IonIcon icon={trashBin} slot="start" color="danger"></IonIcon>
          <IonLabel className="doc-popover-list-item-label" color="danger">
           <Trans>Elimina</Trans> 
          </IonLabel>
        </div>
      </IonList>
    </IonPopover>
  );
};

export default FileActionPopover;